import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Loader, Dropdown } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import 'tippy.js/dist/tippy.css';
import tippy from 'tippy.js';
import moment from 'moment';

import { ScheduleService } from '../../services/methods/ScheduleService';

import { useSchedule } from '../../hooks/schedules';
import { useUser } from '../../hooks/user';
import { OsService } from '../../services/methods/OsService';
// import { ScheduleService } from '../../services/methods/ScheduleService'; // Already imported
import { useAuth } from '../../hooks/auth';

import { OutgoingOSModal } from '../../components/OutgoingOsModal';
import { LaunchOSModal } from '../../components/LaunchOSModal';
import SideMenu from '../../components/SideMenu';
import Header from '../../components/Header';

import FullCalendar, { } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';
import { AnimatePresence, motion } from 'framer-motion';

import { pickTextColorBasedOnBgColorSimple } from '../../utils/getFontDarkOrLight';

import { styleSheet } from '../../assets/styles/global';

import {
  Container, MainBody, CalendarContainer, Calendar, Load,
  Tips, TipGroup, Text, Receive,
  SelectAnalystContainer, Overlay, SelectAnalystContent, AnalystContainer,
  AnalystName,
  Checkbox,
  Checkmark,
  DetailContainer,
  Detail,
  DetailText,
  Tip,
  Title,
  PeriodHeader
} from './styles';

/* Animation Variants */
const variants = {
  enter: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
  }),
  center: {
    x: 0,
  },
  exit: (direction: number) => ({
    x: direction > 0 ? '-100%' : '100%',
  })
};

const Schedule: React.FC = () => {
  const scheduleService: ScheduleService = new ScheduleService();
  const osService: OsService = new OsService();

  const [showMoney, setShowMoney] = useState(false)
  const [modalSelectAnalyst, setModalSelectAnalyst] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)


  const { userIsLogged } = useAuth()
  const { userInfo } = useUser()

  const {
    month,
    year,
    calendarHeight,
    isOpenLaunchOSModal,
    isOpenOutgoingOSModal,
    launchOsModalData,
    fullCalendarData,
    currentDate,
    isLoading,
    handleEventClick,
    renderEventContent,
    loadSchedulesData,
    handleCloseLaunchOSModal,
    handleCloseOutgoingOSModal,
    setMonth,
    setYear,
    filterSchedules,
    filter,
    setFilter,
    schedules,
    receiveIsUpdate,
    setReceiveIsUpdate,
    handleFetchAnalyst,
    fetchAnalystLoad,
    analistas,
    setAnalyst,
    analyst,
    coordinators,
    updateSchedulesData,
  } = useSchedule()

  const prevDateRef = useRef({ month, year });
  const directionRef = useRef(1);

  if (year !== prevDateRef.current.year || month !== prevDateRef.current.month) {
    if (year > prevDateRef.current.year || (year === prevDateRef.current.year && month > prevDateRef.current.month)) {
      directionRef.current = 1;
    } else {
      directionRef.current = -1;
    }
  }

  useEffect(() => {
    prevDateRef.current = { month, year };
  }, [month, year]);

  const history = useHistory()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')
    window.location.reload();
  }

  useEffect(() => {
    loadSchedulesData(month, year)
    setReceiveIsUpdate(false)
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!userIsLogged()) {
      history.push('/login')
    }
    // eslint-disable-next-line
  }, [])
  const activeDate = moment(`${year}-${String(month).padStart(2, '0')}-26`).subtract(1, 'month').format('YYYY-MM-DD');

  const handleDeleteOS = async (idToDelete: string, recno: number) => {
    try {
      alert(`PARENT: Recebido ID: ${idToDelete}`);
      console.log('PARENT (SCHEDULE) DELETING OS:', idToDelete);
      const userToken = await sessionStorage.getItem('token') || await localStorage.getItem('ethosxAnalista:token');

      // 1. Delete
      const { data: deleteResponse } = await osService.deleteOS(idToDelete, userToken!)

      if (deleteResponse.status === 'ok') {
        toast.success(deleteResponse.msg)

        // 2. Refresh
        const analistaCode = (userInfo.cargo === 'C' && analyst !== "") ? analyst : userInfo.codigo
        const { data: responseData } = await scheduleService.index(userToken!, 0, 0, false, analistaCode, recno)

        if (responseData.status === 'ok' && responseData.analista.agendas.length > 0) {
          updateSchedulesData(responseData.analista)
        }
      } else {
        toast.error(deleteResponse.msg)
      }

    } catch (error) {
      console.error('DELETE ERROR:', error);
      toast.error('Erro ao excluir OS');
    }
  }

  return (
    <>
      <SideMenu currentMenu="calendario" visible={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <Container>
        {/* SideMenu removed from here */}

        <MainBody>
          <Header screen="Calendário" logout={handleLogout} onOpenMenu={() => setIsSidebarOpen(true)} />

          <CalendarContainer style={{ position: 'relative' }}>
            <Calendar>
              <PeriodHeader>
                <Title>Período Mês:</Title>
                <Dropdown
                  placeholder='Mês'
                  selection
                  options={[
                    { key: 1, text: 'Janeiro', value: 1 },
                    { key: 2, text: 'Fevereiro', value: 2 },
                    { key: 3, text: 'Março', value: 3 },
                    { key: 4, text: 'Abril', value: 4 },
                    { key: 5, text: 'Maio', value: 5 },
                    { key: 6, text: 'Junho', value: 6 },
                    { key: 7, text: 'Julho', value: 7 },
                    { key: 8, text: 'Agosto', value: 8 },
                    { key: 9, text: 'Setembro', value: 9 },
                    { key: 10, text: 'Outubro', value: 10 },
                    { key: 11, text: 'Novembro', value: 11 },
                    { key: 12, text: 'Dezembro', value: 12 },
                  ]}
                  value={month}
                  onChange={async (e, { value }) => {
                    const newMonth = Number(value);
                    setMonth(newMonth);
                    await loadSchedulesData(newMonth, year);
                  }}
                />
                <Dropdown
                  placeholder='Ano'
                  selection
                  options={Array.from({ length: 11 }, (_, i) => {
                    const y = new Date().getFullYear() - 5 + i;
                    return { key: y, text: y.toString(), value: y };
                  })}
                  value={year}
                  onChange={async (e, { value }) => {
                    const newYear = Number(value);
                    setYear(newYear);
                    await loadSchedulesData(month, newYear);
                  }}
                />
                {userInfo.cargo === 'C' && (
                  <div style={{ marginLeft: 20 }}>
                    <Dropdown
                      placeholder='Selecionar Analista'
                      selection
                      search
                      options={analistas.map(a => ({ key: a.codigo, text: a.nome, value: a.codigo }))}
                      value={analyst}
                      onChange={async (e, { value }) => {
                        setAnalyst(value as string);
                        await loadSchedulesData(month, year, value as string);
                      }}
                      onOpen={async () => {
                        if (analistas.length === 0) await handleFetchAnalyst();
                      }}
                    />
                  </div>
                )}
              </PeriodHeader>

              <div style={{ position: 'relative', flex: 1, width: '100%', overflow: 'hidden' }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#ffffff',
                  zIndex: 0
                }}>
                  <Loader active inline='centered'>Carregando</Loader>
                </div>

                <AnimatePresence exitBeforeEnter custom={directionRef.current}>
                  {!isLoading && (
                    <motion.div
                      key={`${month}-${year}`}
                      custom={directionRef.current}
                      variants={variants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                      transition={{
                        x: { type: "tween", duration: 0.8, ease: "easeInOut" }
                      }}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#ffffff',
                        zIndex: 10
                      }}
                    >
                      <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        headerToolbar={false}
                        eventContent={renderEventContent} // Pass the context function
                        views={{
                          dayGridMonth: {
                            type: "month",
                            duration: { week: moment(activeDate).isoWeekday() >= 6 ? 6 : 5 },
                            buttonText: "4 Weeks",
                            fixedWeekCount: false
                          }
                        }}
                        stickyHeaderDates={false}
                        initialView='dayGridMonth'
                        editable={false}//true
                        selectable={true}
                        selectMirror={true}
                        firstDay={1}
                        // dayMaxEvents={true}

                        weekends={true}
                        events={fullCalendarData}
                        initialDate={activeDate}
                        key={`${month}-${year}-${analyst}`}
                        visibleRange={{
                          start: activeDate,
                          end: moment(activeDate).add(1, 'month').format('YYYY-MM-DD')
                        }}
                        // select={handleDateSelect}
                        // eventContent={renderEventContent}
                        eventClick={handleEventClick}
                        eventMouseEnter={(arg) => tippy(arg.el, { content: `Projeto: ${arg.event.extendedProps.codpro} - ${arg.event.extendedProps.projeto}  <br>Cliente: ${arg.event.extendedProps.codcli} - ${arg.event.extendedProps.nomecli} <br>Coordenador: ${arg.event.extendedProps.nomeCoordenador}`, theme: 'material', allowHTML: true })}
                        // eventsSet={this.handleEvents}
                        height="100%"
                        // contentHeight={calendarHeight - 100}
                        dragScroll={true}
                        expandRows={true}
                        locale='pt'
                        moreLinkContent={function (args) {
                          return '+' + args.num + ' Agendas';
                        }}
                        dayCellClassNames={function (args) {
                          const startDate = moment(activeDate).format('YYYY-MM-DD')
                          const finalDate = moment(startDate).add(1, 'month').add(1, 'day').format('YYYY-MM-DD')
                          if (moment(args.date).isBetween(startDate, finalDate)) {
                            return 'inPeriod'
                          } else {
                            return 'notInPeriod'
                          }
                        }}
                      />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Calendar>


            {
              modalSelectAnalyst &&
              <>
                <Overlay onClick={() => setModalSelectAnalyst(false)} />
                <SelectAnalystContainer>
                  <SelectAnalystContent>
                    {
                      fetchAnalystLoad ?
                        <Load><Loader active inline='centered'>Carregando</Loader></Load>
                        :

                        analistas.map(analyst => (
                          <AnalystContainer onClick={async () => {
                            await setAnalyst(analyst.codigo)
                            setModalSelectAnalyst(false)
                            await loadSchedulesData(month, year, analyst.codigo)
                          }} color={analyst.color === '' ? '#cccccc' : analyst.color}>
                            <AnalystName style={{ color: pickTextColorBasedOnBgColorSimple(analyst.color) }} >{analyst.nome}</AnalystName>
                          </AnalystContainer>
                        ))
                    }
                  </SelectAnalystContent>
                </SelectAnalystContainer>
              </>
            }
          </CalendarContainer>
        </MainBody>
      </Container>

      {/* Handlers defined inside render to access hook state */}
      {(() => {
        // Define deletion handler here or outside? 
        // Better: Define handleDeleteOS inside the component body.
        return null;
      })()}

      {isOpenLaunchOSModal && <LaunchOSModal visible={isOpenLaunchOSModal} data={launchOsModalData} closeModal={handleCloseLaunchOSModal} onDelete={handleDeleteOS} />}

      {
        isOpenOutgoingOSModal && <OutgoingOSModal visible={isOpenOutgoingOSModal} data={launchOsModalData} closeModal={handleCloseOutgoingOSModal} />
      }
    </>
  );
}

export default Schedule;